import {Injectable} from "@angular/core";
import {
    GetSimilarProductsOfProductsUseCase
} from "@app/core/product/application/get-similar-products-of-products.use-case";
import {BehaviorSubject, Observable} from "rxjs";
import {Product} from "@app/core/product/domain/dtos/product";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {take} from "rxjs/operators";

@Injectable()
export class SimilarProductsViewModel {

    private similarProductsStatus = createStatusStore();
    isSimilarProductsLoading$ = this.similarProductsStatus.isLoading$;

    private similarProductsSubject = new BehaviorSubject<Product[]>([]);
    similarProducts$: Observable<Product[]> = this.similarProductsSubject.asObservable()

    constructor(
        private getSimilarProductsOfProductsUseCase: GetSimilarProductsOfProductsUseCase
    ) {
    }

    loadSimilarProducts(productCodes: string[], itemsPerPage: number) {
        this.getSimilarProductsOfProductsUseCase.execute(productCodes, itemsPerPage, 1)
            .pipe(
                take(1),
                onIsLoadingChanges(this.similarProductsStatus.setIsLoading)
            )
            .subscribe({
                next: similarProducts => this.similarProductsSubject.next(similarProducts)
            })
    }
}
